module.exports = __webpack_public_path__ + "static/img/img_03.453dc993.png";